import {
  getSettings,
  saveCustomDomainList,
  saveDefaultCustomDomain,
  validateEmailSenderDomainConfig
} from '@/services/companySettingsService'
import { ElMessageBox, ElMessage } from 'element-plus'
export default {
  name: 'CustomDomainComponent',
  data() {
    return {
      loading: true,
      savingData: false,

      domainList: null,
      defaultDomain: '',

      domainListSettingKey: 'campaign-tracking-custom-domain-list',
      defaultDomainSettingKey: 'campaign-tracking-custom-domain',

      domainVerification: {
        dialogVisible: false,
        domain: null,
        inProgress: true,
        ssl: {
          valid: null,
          message: null
        },
        cname: {
          valid: null,
          message: null
        }
      }
    }
  },

  methods: {
    async showAddDomainDialog() {
      ElMessageBox.prompt('Enter Domain Name', 'Add Custom Domain', {
        confirmButtonText: 'Save',
        cancelButtonText: 'Cancel',
        inputPattern: /^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/,
        inputErrorMessage: 'Invalid Domain format. Please enter a valid domain name.'
      })
        .then(({ value }) => {
          this.addDomain(value)
        })
        .catch(() => {
          ElMessage({
            type: 'info',
            message: 'Input canceled'
          })
        })
    },

    async addDomain(domainName) {
      try {
        this.loading = true
        // Check if domain is already in the list.
        if (this.domainList && this.domainList.includes(domainName)) {
          this.errorToast('Domain already exists in the list.')
          this.loading = false
          return
        }

        // Save Domain.
        const list = JSON.parse(JSON.stringify(this.domainList))
        list.push(domainName)
        await saveCustomDomainList(list)

        // Refresh data.
        await this.fetchData()

        ElMessage({
          type: 'success',
          message: 'Domain Added.'
        })

        this.loading = false
      } catch (e) {
        this.reportError(e)
        ElMessage({
          type: 'error',
          message: 'Failed to add domain. Please contact support.'
        })
      }
    },

    async removeDomain(index) {
      // Ask for confirmation before removing the domain
      const confirm = await this.$confirm('Are you sure you want to remove this domain?', 'Remove Domain', {
        confirmButtonText: 'Remove',
        cancelButtonText: 'No'
      })
      if (confirm) {
        try {
          this.loading = true

          // Save Domain.
          const list = JSON.parse(JSON.stringify(this.domainList))
          list.splice(index, 1)
          await saveCustomDomainList(list)

          // Refresh data.
          await this.fetchData()

          ElMessage({
            type: 'success',
            message: 'Domain Removed.'
          })

          this.loading = false
        } catch (e) {
          this.reportError(e)
          ElMessage({
            type: 'error',
            message: 'Failed to remove domain. Please contact support.'
          })
        }
      }
    },

    async setDefaultDomain(domain) {
      // Ask for confirmation before removing the domain
      const confirm = await this.$confirm('Are you sure you want to set this domain as default?', 'Set Default Domain', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No'
      })
      if (confirm) {
        try {
          this.loading = true

          // Save Default Domain.
          await saveDefaultCustomDomain({ domain: domain })

          // Refresh data.
          await this.fetchData()

          ElMessage({
            type: 'success',
            message: 'Domain Set as Default.'
          })

          this.loading = false
        } catch (e) {
          this.reportError(e)
          ElMessage({
            type: 'error',
            message: 'Failed to set domain as default. Please contact support.'
          })
        }
      }
    },

    async fetchData() {
      this.loading = true
      try {
        let res = await getSettings([this.domainListSettingKey])
        this.domainList = []
        if (res.data && res.data.length > 0) {
          this.domainList = JSON.parse(res.data[0].value)
        }

        // Fetch default domain.
        res = await getSettings([this.defaultDomainSettingKey])
        if (res.data && res.data.length > 0) {
          this.defaultDomain = res.data[0].value || null
        }

        this.loading = false
      } catch (e) {
        this.reportError(e)
        ElMessage({
          type: 'error',
          message: 'Failed to fetch data. Please contact support.'
        })
      }
    },

    // #region --------- Start: Domain Verification  ---------

    async verifyDomainConfiguration(domain) {
      this.domainVerification.dialogVisible = true
      this.domainVerification.domain = domain
      this.domainVerification.inProgress = true
      this.domainVerification.ssl = null
      this.domainVerification.cname = null

      // validateEmailSenderDomainConfig('abcdef.growlytics.in')
      validateEmailSenderDomainConfig(domain)
        .then(res => {
          this.domainVerification.inProgress = false
          this.domainVerification.ssl = res.data.ssl
          this.domainVerification.cname = res.data.cname
        })
        .catch(e => {
          this.reportError(e)
          ElMessage({
            type: 'error',
            message: 'Failed to verify domain configuration. Please contact support.'
          })
        })
    }

    // #endregion --------- End: Domain Verification  ---------
  },

  mounted() {
    this.fetchData()
  }
}
